import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins'


// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData            from '../primitives/localData'

import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'

import lmx_Events               from './Events'

import lmx_draw_Forms           from './draw_Forms'
import lmx_chart_Router         from './chart_Router'
import lmx_ChartCanvas          from './draw_ChartCanvas'
import lmx_Timeline             from './draw_Timeline'
import lmx_Chart                from './draw_Chart'
import lmx_Table                from './draw_Table'
import lmx_Summary              from './draw_Summary'
import lmx_Milestones           from './draw_Milestones'
import lmx_Legends              from './draw_Legends'
import lmx_draw_PDF             from './draw_PDF'



export default {
  mixins: [
    gmx_zMixins, 
    lmx_localData,

    // Local Mixins
    lmx_Watching,
    lmx_Events,
    
    lmx_LocalValues,
    
    lmx_draw_Forms,
    lmx_chart_Router,
    lmx_ChartCanvas,
    lmx_Timeline,
    lmx_Chart,
    lmx_Table,
    lmx_Summary,
    lmx_Milestones,
    lmx_Legends,

    lmx_draw_PDF,
  ],
}
